module.exports = __webpack_public_path__ + "static/media/FicusEducation_Logo_Secondary_CROPPED_CMYK.2b7811d7.png";